import styles from "./styles.module.css";

const Item = ({ flag, name, onClick = () => {}, className = "" }) => {
  return (
    <button onClick={onClick} className={`${styles.btn} ${className}`}>
      <img src={flag} className={styles.flag} />
      <p className={styles.text}>{name}</p>
    </button>
  );
};

export default Item;
